/** Web de import eder; zod'suz kalmalı: ygg-types.ts'ten bir import, zod şemalarını web paketine çeker (+59 kB). */
export const MANUAL_SECTION_LABELS = {
    customerFeedback: 'Müşteri Geri Bildirimi ve Memnuniyeti',
    supplierPerformance: 'Tedarikçi Performansı (§8.4)',
    resourceAdequacy: 'Kaynakların Yeterliliği',
    riskOpportunities: 'Risk ve Fırsatlara Yönelik Faaliyetlerin Etkinliği (§6.1)',
    contextChanges: 'İç ve Dış Bağlam Değişiklikleri (§4.1/4.2)',
    improvementSuggestions: 'İyileştirme Fırsatları',
};
//# sourceMappingURL=ygg-section-labels.js.map